/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react'

import { FadeSwap, Loader, EditorialSplitImage, Label } from '@pb/components'
import { trackEvent, useRequest } from '@pb/utils'

import { ACCOUNT_ROUTES } from 'App/constants'
import { PAGE_IDS } from 'features/account/helpers/getAccountTrackingData'

import { DIGITAL_STYLIST_TRACKING_EVENTS } from '../../constants'
import useTrackPageViewEvent from '../../hooks/useTrackPageViewEvent'
import { quizLandingPageConfigPath } from './constants'

const QuizEditorialPage: React.FC = () => {
  const { data: quizLandingPageConfig, loading: isLoadingQuizLandingPageConfig } =
    useRequest(quizLandingPageConfigPath)

  useTrackPageViewEvent(PAGE_IDS.digitalStylistEditorialPage)

  return (
    <FadeSwap
      flag={isLoadingQuizLandingPageConfig}
      placeholder={<Loader data-testid="quiz-editorial-page-loader" />}
    >
      {quizLandingPageConfig && (
        <EditorialSplitImage
          imageUrl={quizLandingPageConfig.image}
          imageAltText={quizLandingPageConfig.imageAltLabel}
          headline={<Label copyKey={'digitalstylist.title'} />}
          bodyText={<Label copyKey={quizLandingPageConfig.descriptionTextLabel} />}
          ctaLink={ACCOUNT_ROUTES.DigitalStylist.path}
          ctaText={<Label copyKey={quizLandingPageConfig.primaryActionLabel} />}
          onClick={() => trackEvent(DIGITAL_STYLIST_TRACKING_EVENTS.editorial)}
        />
      )}
    </FadeSwap>
  )
}

export default QuizEditorialPage
